module.exports = __webpack_public_path__ + "images/testimonial-yuvraj-shivaji-dhepe.webp";